import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { createTaskFolderService, updateTaskFolderService } from '../../../../../services/tasks';

const ManageFolderModal = ({ closeModal, handleSuccess, folderData, companyId, parentId }) => {
  const isEditing = !!folderData?.id;

  const [name, setName] = useState('');
  const [errors, setErrors] = useState({});
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    setName(folderData?.name ?? '');
  }, [folderData]);

  const handleChange = (value) => {
    setName(value);
    setErrors({});
  };

  const handleSubmit = async () => {
    setIsDisabled(true);

    const request = isEditing
      ? updateTaskFolderService({ name }, folderData.id)
      : createTaskFolderService({ name, parent_id: parentId, company_id: companyId });

    request
      .then((response) => {
        handleSuccess(response?.data?.id);
        closeModal();
      })
      .catch((e) => {
        setErrors(e?.response?.data ?? {});
      })
      .finally(() => setIsDisabled(false));
  };

  return (
    <Modal className="modal-default" isOpen onRequestClose={closeModal} contentLabel="Manage Folder Modal" ariaHideApp={false}>
      <h2 className="modal-header">
        {isEditing ? 'Edit' : 'Add New'} folder
        <button className="btn btn-icon" onClick={closeModal}>
          <i className="icon-icon-x" />
        </button>
      </h2>
      <div className="form-wrapper">
        <h3 className="form-wrapper-title">
          <img src="/images/folder-icon-default.png" alt="" />
          Folder information
        </h3>
        <div className={`form-item ${errors.name?.[0] ? 'form-item-error' : ''}`}>
          <label className="form-label">Folder Name</label>
          <input
            placeholder="Enter the folder name"
            value={name}
            onChange={(e) => handleChange(e.target.value)}
            type="text"
            className="form-control"
          />
          <span className="form-error">{errors.name?.[0]}</span>
          <span className="form-error">{errors.parent_id?.[0]}</span>
          <span className="form-error">{errors.company_id?.[0]}</span>
        </div>
      </div>

      <div className="modal-footer">
        <button className="btn btn-outline" onClick={closeModal}>
          Cancel
        </button>
        <button disabled={isDisabled || !name.trim().length} className="btn" onClick={handleSubmit}>
          Save
        </button>
      </div>
    </Modal>
  );
};

export default ManageFolderModal;
